import React from "react";
import { Grid } from "@mui/material";
import { FaArrowRight } from "react-icons/fa6";
import { NewsDateConverter } from "../../Components/Helpers/DateTimeConverter";
import NewsSkeleton from "../Loader/NewsSkeleton";
import defaultNewsImage from "../../Assets/Images/default-image.png";


const NewsSection = ({ 
  news = [], 
  loading = false, 
  error = null, 
  onRetry = null,
  onNewsClick = null,
  getNewsImage = null
}) => {
  return (
    <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"} className="mt-3">
      {loading ? (
        <NewsSkeleton count={3} />
      ) : news.length > 0 ? (
        news.map((val, index) => (
          <Grid 
            item 
            container 
            key={val.id || index} 
            lg={3.8} 
            md={3.8} 
            sm={12} 
            xs={12} 
            backgroundColor={"#F2F2F2"} 
            borderRadius={"20px"} 
            className="mb-4"
            onClick={() => onNewsClick && onNewsClick(val)}
            onKeyDown={(e) => {
              if (onNewsClick && (e.key === "Enter" || e.key === " ")) {
                onNewsClick(val);
              }
            }}
            tabIndex={onNewsClick ? 0 : -1}
            role={onNewsClick ? "button" : "article"}
            aria-label={onNewsClick ? `Read news: ${val.title}` : undefined}
            sx={onNewsClick ? { 
              cursor: "pointer", 
              "&:hover": { 
                transform: "translateY(-2px)", 
                transition: "transform 0.2s ease" 
              } 
            } : {}}
          >
            <Grid 
              item 
              container 
              lg={12} 
              md={12} 
              sm={12} 
              xs={12} 
              overflow={"hidden"} 
              justifyContent={"center"} 
              alignItems={"center"} 
              height={"30vh"}
              sx={{ 
                borderRadius: "20px 20px 0 0",
                overflow: "hidden"
              }}
            >
              <img
                src={getNewsImage ? getNewsImage(val) : (val.bannerPic || val.featuredImage || defaultNewsImage)}
                alt="News"
                className="img-fluid"
                style={{ 
                  objectFit: "cover", 
                  width: "100%", 
                  height: "100%",
                  borderRadius: "20px 20px 0 0"
                }}
                onError={(e) => {
                  e.target.src = defaultNewsImage;
                }}
              />
            </Grid>
            <Grid item container lg={12} md={12} sm={12} xs={12} flexDirection={"column"} padding={"4%"}>
              <p className="fontSize12 text-black poppinsMedium text-left" style={{ color: "#5D5D5D" }}>
                {NewsDateConverter(val.date)}
              </p>
              <h5 
                style={{ 
                  textTransform: "uppercase",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: "1.3"
                }} 
                className="poppinsMedium text-black text-left pt-2 w-100"
              >
                {val?.title}
              </h5>
              <p style={{ color: "#306A47" }} className="poppinsSemiBold text-black text-left pointer pt-4">
                Continue {" "}<FaArrowRight color={"#306A47"} size={16} />
              </p>
            </Grid>
          </Grid>
        ))
      ) : (
        <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
          <h5 className="text-black poppinsMedium mt-3 mb-3">
            {error ? "Unable to load news. Please try again later." : "No Latest News Available"}
          </h5>
          {error && onRetry && (
            <button 
              onClick={onRetry}
              className="poppinsMedium"
              style={{ 
                backgroundColor: "#306A47", 
                color: "white", 
                border: "none", 
                padding: "8px 16px", 
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Retry
            </button>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default NewsSection;
